var ValuesOr = require("./values-or");
var ValuesNot = require("./values-not");
var ValuesAnd = require("./values-and");
var KeysAnd = require("./keys-and");

module.exports = {
    KeysAnd: KeysAnd,
    ValuesOr: ValuesOr,
    ValuesNot: ValuesNot,
	ValuesAnd: ValuesAnd
};
